import React from "react";
import { FeedPostTab } from "@/pages/FeedPosts/FeedPostOverview/FeedPostsTable/FeedPostTab";
import {
  FeedPostSortableFieldEnum,
  FeedPostStatusEnum,
  SortDirectionEnum,
} from "@/__generated__/graphql";
import { useTranslation } from "react-i18next";

export const FeedPostsTab = () => {
  const { t } = useTranslation();

  return (
    <FeedPostTab
      statuses={[FeedPostStatusEnum.Active, FeedPostStatusEnum.Scheduled]}
      title={t("feedPost.communityToolsOverview.tabs.feedPost.title")}
      subtitle={t("feedPost.communityToolsOverview.tabs.feedPost.subtitle")}
      emptyState={t("feedPost.communityToolsOverview.tabs.feedPost.emptyState")}
      ordering={[
        {
          field: FeedPostSortableFieldEnum.CreatedAt,
          direction: SortDirectionEnum.Desc,
        },
      ]}
    />
  );
};
